export const PROSPECT_DETAILS_CHANGE_TRACKING = {
  prospectInformation: {
    source: 'prospect_details.prospect_information',
    id: 25201,
  },
  address: {
    source: 'prospect_details.address',
    id: 25202,
  },
  contact: {
    source: 'prospect_details.contact',
    id: 25203,
  },
  followUp: {
    source: 'prospect_details.follow_up',
    id: 25204,
  },
  uploadDocuments: {
    source: 'prospect_details.upload_documents',
    id: 25205,
  },
  notes: {
    source: 'prospect_details.notes',
    id: 25206,
  },
  callLog: {
    source: 'prospect_details.call_log',
    id: 25207,
  },
  uploadDocumentsUpload: {
    source: 'prospect_details.upload_documents.upload',
    id: 25301,
  },
  uploadDocumentsDelete: {
    source: 'prospect_details.upload_documents.delete',
    id: 25302,
  },
  notesAdd: {
    source: 'prospect_details.notes.add_comment',
    id: 25303,
  },
  notesDelete: {
    source: 'prospect_details.notes.delete_comment',
    id: 25304,
  },
  callLogAdd: {
    source: 'prospect_details.call_log.add_comment',
    id: 25305,
  },
  callLogDelete: {
    source: 'prospect_details.call_log.delete_comment',
    id: 25306,
  },
  followUpSetReminder: {
    source: 'prospect_details.follow_up.set_reminder',
    id: 25307,
  },
} as const;
